<template lang="pug">
  .v-container.grid-container.u-margin-auto
    div(v-cloak)
      .row
        .col.s12
          h1.h5.u-weight-bold Select a Payment Method
      .row.u-mtm
        div
          .row
            .col.s12
              .v-payments
                vue-payments-select(
                  ref='paymentsSelect',
                  service="shop",
                  :recaptcha-site-key="recaptchaSiteKey",
                  :stripe-key="stripeKey",
                  :unavailable-payment-methods='unavailablePaymentMethods',
                  :ignore-current="false",
                  button-label="Review Your Order",
                  @change='selectPayment'
                )

</template>

<script>
import { Payment } from '../../../stores/schema/Payment';

import paymentsSelectComponent from '../../../components/payments/PaymentsSelect.vue';

export default {
  name: 'select_payment_method',

  components: {
    'vue-payments-select': paymentsSelectComponent
  },

  data() {
    return {};
  },

  props: {
    stripeKey: {
      type: String
    },
    recaptchaSiteKey: {
      type: String
    }
  },

  computed: {
    cart() {
      return this.$store.getters['cart/current']();
    },

    unavailablePaymentMethods() {
      let result = this.cart.unavailable_payment_methods.join(',');
      if (this.cart.premium.is_joining) {
        return `${result},amazon`;
      }
      return result;
    },

    currentPayment() {
      return Payment.getCurrent();
    },

    isPremiumMember() {
      return !!this.$store.state.user.is_premium_member;
    },

    willJoinPremium() {
      return !!this.$store.state.user.will_join_premium;
    },

    hadRegisteredPremiumInPast() {
      return !!this.$store.state.user.had_registered_premium_in_past;
    },

    canGetBonus() {
      return (
        this.cart.premium.can_get_bonus &&
        !this.currentPayment.already_used_for_premium
      );
    }
  },

  methods: {
    onAuthError() {
      window.location.href = '/login?re_auth=1&r=/checkout/payments';
    },

    selectPayment() {
      if (this.submitButtonDisabled) {
        return false;
      }

      this.loadingContainer = true;

      Promise.resolve()
        .then(() => {
          // 既にプレミアムに入会済みの場合は実行しない
          if (this.isPremiumMember) {
            this.$store.dispatch('cart/enebleToPurchase');
            return Promise.resolve();
          }

          // 入会状態を切り替える画面では無いのでuser/willJoinPremiumは更新していない
          return this.$store.dispatch('cart/joinPremium', {
            wishlist_id: this.cart.wishlistId,
            join: this.willJoinPremium
          });
        })
        .then(() => {
          this.loadingContainer = false;

          // プレミアム加入しようとしていてプレミアム決済として既に使用されているクレジットカードが選択された場合はアラートを出す
          if (
            this.willJoinPremium &&
            !this.hadRegisteredPremiumInPast &&
            !this.canGetBonus
          ) {
            this.$alert(
              'This payment method is already linked to another account. Please know any orders paid for by this payment method will not include first-time purchaser benefits of any kind in relation to TOM services.'
            ).then(() => {
              this.$router.push('/checkout').catch(() => {});
            });
            return false;
          }

          this.$router.push('/checkout').catch(() => {});
        })
        .catch((error) => {
          this.loadingContainer = false;

          this.$alert(
            error.general ||
              'An error occurred. Please wait a moment before trying again.'
          );
        });
    }
  }
};
</script>

<style scoped>
.v-container {
  max-width: 640px;
}

.v-loading {
  min-height: 50vh;
}

.v-payments {
  border-top: 1px solid #cccccc;
}

.v-payment {
  border-bottom: 1px solid #cccccc;
  font-weight: normal;
  margin-bottom: 0;
  padding: 10px;
}

.v-cards {
  display: none;
}

.v-card {
  font-weight: normal;
  margin-bottom: 0;
  padding: 10px;
}

.v-payment.selected {
  background: #d5e9f4;
}

.v-payment.selected .v-cards {
  display: block;
}

.v-payment.selected .v-cards .v-card.selected {
  background: #95cbe8;
}

.v-form {
  background: white;
  padding: 20px 20px 0;
}

.v-billing-address {
  white-space: pre;
}

.v-panel-link {
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
  min-height: 150px;
}

/* iOS Safariでデバイス高よりモーダル高が大きい場合にツールバーが被さってボタンが押下出来ない問題のワークアラウンド */
@media (max-width: 767px) {
  .v-modal-container {
    padding-bottom: 100px !important;
  }
}
</style>
